import React from "react";
import { Helmet } from "react-helmet";
import cardimg from "../assets/images/cardImg.png";

export default function HelmetComponent() {
  return (
    <Helmet>
      <title>Joe's Pressure Washing</title>
      {/* SEO Tags */}
      <meta name="description" content="Joe's Pressure Washing" />
      <meta name="google" content="nositelinkssearchbox" />
      {/* <!-- Search Engine Meta Tags --> */}
      <meta name="robots" content="..., ..." />
      <meta name="http-equiv" content="X-Robots-Tag : follow" />
      <meta name="googlebot" content="..., ..." />
      {/* <!-- Site Ownership Meta Tag --> */}
      <meta name="verify" content="" />

      <meta property="og:url" content="https://joespressurewashing.com/" />
      <meta property="og:title" content="Joe's Pressure Washing" />
      {/* <!-- Facebook Content Tags --> */}
      <meta property="og:site_name" content="Joe's Pressure Washing" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en-IN" />
      <meta property="og:image" content={cardimg} />
      <meta property="og:description" content="Washing Done Right!" />
      {/* <!-- Twitter Content Tags --> */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Joes Pressure Washing" />
      <meta name="twitter:description" content="Washing Done Right!" />
      <meta name="twitter:image" content={cardimg} />
    </Helmet>
  );
}
